var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 28,
    fill: "#030712"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 44,
    r: 14,
    fill: "#06B6D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 60 L60 98 L104 28",
    stroke: "#06B6D4",
    strokeWidth: 26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconDark);
export default __webpack_public_path__ + "static/media/app_icon_dark.644b99d5dd19615245af23603235e357.svg";
export { ForwardRef as ReactComponent };